import {i18n, Icon} from 'mc/lib';
import {PropTypes} from 'prop-types';
import React from 'react';

const Loading = ({block, children}) => {
    const icon = <Icon icon="spinner" animation={Icon.animation.spin}/>;
    const message = children || <em>{i18n('global.loading')}</em>;

    if (block) {
        const outerDivStyle = {
            position: 'relative',
            height: block === 'full' ? '100%' : undefined,
            width: '100%',
            minHeight: '400px',
        };

        const innerDivStyle = {
            position: 'absolute',
            top: '50%',
            marginTop: '-20px',
            width: '100%',
            textAlign: 'center',
        };

        return (
            <div className="loading" style={outerDivStyle}>
                <div style={innerDivStyle}>{icon} {message}</div>
            </div>
        );
    }

    return <div className="loading">{icon} {message}</div>;
};

Loading.propTypes = {
    block: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.oneOf(['full']),
    ]),
};

Loading.defaultProps = {
    block: false,
};

export default Loading;
